import { HandlerType, Message } from '@ftr/bus-messages';
export class HearingAnnotationsUpdatedMessage extends Message {
    constructor(recordingId) {
        super();
        this.recordingId = recordingId;
        this.$name = 'ftr-annotations/HearingAnnotationsUpdatedMessage';
        this.$version = 0;
        this.$handlerType = HandlerType.NativeSqs;
    }
}
